module.exports = __webpack_public_path__ + "static/img/cd.211655b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cd.jpg
// module id = 2u2h
// module chunks = 1